import React from "react";

/**
 * props:
 *  - String label
 *  - (int || null) dropDownVal
 *  - Array<LookupTable> options
 *  - String lookupType
 *  - Boolean editMode
 *  - function handleChange
 */
const UserOptionsDropdown = (props) => {
  console.log("EDIT MODE", props.editMode);
  const val = props.dropDownVal;
  const opts = props.options.map((opt) => {
    if (opt.name == "FACULTY") {
      opt.name = "FACULTY/STAFF";
    }
    return (
      <option value={opt.id} key={props.lookupType + opt.id}>
        {opt.name}
      </option>
    );
  });

  return props.editMode ? (
    <fieldset className="pt-3">
      {console.log("props: ", props)}
      <label className="pr-1" htmlFor={props.lookupType + "Dropdown"}>
        {props.label}
      </label>
      <select
        id={props.lookupType + "Dropdown"}
        className="btn btn-secondary"
        name={"user[" + props.lookupType + "_id]"}
        value={val ? val.id : 0}
        onChange={(e) =>
          props.handleChange(
            {
              key: props.lookupType,
              ddOpts: props.options,
            },
            e
          )
        }
      >
        {" "}
        {console.log("options:", props.options)}
        {opts}
      </select>
    </fieldset>
  ) : (
    <div className="pt-3">
      <label className="pr-1" htmlFor={props.lookupType + "Dropdown"}>
        {props.label}
      </label>
      <div id={props.lookupType + "Dropdown"} className="card inner-buffer">
        {val != null ? val.name : ""}
      </div>
    </div>
  );
};

export default UserOptionsDropdown;
